import React, { Component } from 'react'
import ProjectDetail from './ProjectDetail'
import { RouteComponentProps } from 'react-router'
import ProjectMenuBar from './ProjectMenuBar'
import { Project } from '../../schema/types.d'
import WorkPlanner from './WorkPlanner'
import WorkPlannerTable from './WorkPlannerTable'

export enum navPage {
  projectDetail = 'Project Detail',
  workPlanner = 'Work Planner - Gantt',
  workPlannerTable = 'Work Planner - Table',
  employees = 'Employees',
  settings = 'Settings'
}

interface ProjectPageState {
  currentPage: navPage
}

class ProjectPage extends Component<
  RouteComponentProps<{ id: string }>,
  ProjectPageState
> {
  constructor(props) {
    super(props)
    this.changePage = this.changePage.bind(this)
  }

  componentDidMount() {
    this.setState({
      currentPage: navPage.projectDetail
    })
  }

  changePage(pageLink: navPage) {
    this.setState({
      currentPage: pageLink
    })
  }

  mainPage(project: Project.Project) {
    switch (this.state.currentPage) {
      case navPage.workPlanner:
        return <WorkPlanner project={project} />
      case navPage.workPlannerTable:
        return <WorkPlannerTable project={project} />
      case navPage.employees:
        return <div>Employees</div>
      default:
        return <ProjectDetail project={project} />
    }
  }

  render() {
    const id = this.props.match.params.id
    return (
      <Project.Component variables={{ id: id }}>
        {({ loading, error, data }) => {
          if (loading) return ''
          if (error) return <div>Error</div>
          if (!data) return <div>No data!</div>
          const project = data.project
          return (
            <div>
              <ProjectMenuBar project={project} changePage={this.changePage} />
              {this.mainPage(project)}
            </div>
          )
        }}
      </Project.Component>
    )
  }
}

export default ProjectPage
